import React from "react";

import { IProps } from "./types";
import { Container, Row, Col } from "react-bootstrap";
import LogoWeb from "./images/welcome-img-web1.png";
import LogoMobile from "./images/welcome-img-mobile1.png";
import { DeviceContext, deviceType } from "@providers";
import { Button } from "@atoms";
import { Link } from "react-router-dom";
import { baseUrl } from "@src/app/routes";

const WelcomePage: React.FC<IProps> = ({
  // destructure props here if needed
}: IProps) => {
  const isMobile = React.useContext<deviceType>(DeviceContext).isMobile;
  return (
    <Container>
      {
        isMobile ? 
          <img src={LogoMobile} style={{width: "100%"}}/>
        :
          <img src={LogoWeb} style={{width: "100%"}}/>
      }
      <Row>
        <Col md={{span: 6, offset: 3}} xs={12}>
          <Link to={baseUrl}>
            <Button fullWidth style={{marginTop: "2rem"}}>
              Checkout Now &gt;
            </Button>
          </Link>
        </Col>
      </Row>
    </Container>
  )
};

export { WelcomePage }